import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';

export default function useProfilePicture() {
  return useSelector((state: RootState) => state.user.profilePicture);
}

export function useAvatarChecked(): boolean {
  return useSelector((state: RootState) => state.user.avatarChecked);
}
